<div class="shell">
  <aside class="nav">
    <div class="brand">
      <span class="brand-name">Studio CMMS</span>
      <span class="brand-sub">Manutenzione</span>
    </div>
    <nav>
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
      <a routerLink="/machines" routerLinkActive="active">Macchinari</a>
      <a routerLink="/tasks" routerLinkActive="active">Manutenzioni</a>
      <a routerLink="/calendar" routerLinkActive="active">Calendario</a>
      <a routerLink="/alerts" routerLinkActive="active">Alert scadute</a>
      <a routerLink="/extractions" routerLinkActive="active">Review AI</a>
    </nav>
    <div class="user">
      <span>{{ auth.user()?.full_name || 'Utente' }}</span>
      <button type="button" (click)="auth.logout()">Esci</button>
    </div>
  </aside>
  <main class="content">
    <router-outlet />
  </main>
</div>
